cb.define(['common/common_VM.Extend.js'], function (common) {
  var RM_rm_salereceipts_report_filterVM_Extend = {
    doAction: function (name, viewmodel) {
      if (this[name])
        this[name](viewmodel);
    },
    init: function (viewmodel) {
		viewmodel.on('afterInit', function () {
					debugger
					//业务类型参照只显示单据类型为零售单*/
					var conditionBusinesstype = {
						"isExtend": true,
						simpleVOs: []
					};
					//var storeid = cb.rest.AppContext.user.storeId;
					conditionBusinesstype.simpleVOs.push({
						field: 'receipttype.code',
						op: 'eq',
						value1: 'A01'
					});
					viewmodel.get('iBusinesstypeid').getFromModel().setFilter(conditionBusinesstype);
		});
	  
    }
  }
  try {
    module.exports = RM_rm_salereceipts_report_filterVM_Extend;
  } catch (error) {

  }
  return RM_rm_salereceipts_report_filterVM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/RM/RM_rm_salereceipts_report_filterVM.Extend.js